<template>
  <LayoutSite>
    <Formulario titulo="Catálogos de Serviços" v-if="!frmcadastro">
      <v-card-title>
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="openform('novo')"
          :disabled="!permissoes.catalogo_incluir"
        >Novo Catálogo</v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        v-model="selected"
        locale="pt-BR"
      >
        <template v-slot:item="props">
          <tr @dblclick="openform('editar',props.item.id)">
            <td class="text-xs-right">{{ props.item.nome }}</td>
            <td class="text-xs-right">{{props.item.Ativo_descr }}</td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Sua Pesquisa por "{{ search }}" não encontrou registros.</v-alert>
      </v-data-table>
    </Formulario>
    <Formulario :titulo="titulo" v-if="frmcadastro">
      <v-form @submit.prevent="salvar()">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="frmcadastro=false; getData();">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="4">
              <v-text-field label="Nome" name="nome" autofocus v-model="catalogo.nome"></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-switch v-model="catalogo.ativo" label="Ativo"></v-switch>
            </v-col>
          </v-row>
          <Servico :catalogo_id="catalogo_id" v-if="excluir"></Servico>
          <v-alert
            dense
            outlined
            type="error"
            v-for="(erro, index) of erros"
            :key="index"
          >{{erro[0]}}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn
            depressed
            color="error"
            @click="confirmaExcluir()"
            v-if="excluir"
            :disabled="!permissoes.catalogo_excluir"
          >EXCLUIR</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            type="submit"
            :disabled="!permissoes.catalogo_alterar"
          >SALVAR</v-btn>
        </v-card-actions>
        <template>
          <v-row justify="center">
            <v-dialog v-model="exclusao" persistent max-width="400">
              <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>Deseja realmente excluir este Catálogo?</v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="red darken-1" text @click="exclusao = false">NÃO</v-btn>

                  <v-btn color="blue darken-1" text @click="deletar()">SIM</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-form>
    </Formulario>
  </LayoutSite>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";
import Servico from "@/views/catalogo/Servico";

export default {
  components: {
    LayoutSite,
    Formulario,
    Servico
  },
  data() {
    return {
      selected: [],
      search: "",
      headers: [
        { text: "Nome", value: "nome", align: "left" },
        { text: "Ativo", value: "Ativo_descr" }
      ],
      items: [],
      frmcadastro: false,
      excluir: false,
      exclusao: false,
      readonly: true,
      titulo: String,
      erros: [],
      catalogo: {
        id: 0,
        nome: "",
        ativo: "0"
      },
      catalogo_id: 0,
      permissoes: {
        catalogo: false,
        catalogo_incluir: false,
        catalogo_alterar: false,
        catalogo_excluir: false
      }
    };
  },
  created: function() {
    this.getData();

    let permAux = this.$store.getters.getPermissoes;

    if (permAux.ativo) {
      this.permissoes = permAux;
      if (!this.permissoes.catalogo) this.$router.push("/#");
    } else this.$router.push("/#");
  },
  methods: {
    getData: function() {
      this.$http
        .get(this.$urlAPI + "/catalogo", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.items = response.data));
    },
    openform: function(opcao, id) {
      this.frmcadastro = true;
      this.erros = [];
      if (opcao == "novo") {
        this.excluir = false;
        this.titulo = "Novo Catálogo";
        this.catalogo.nome = "";
        this.catalogo.ativo = "1";
        this.catalogo.id = 0;
      } else if (opcao == "editar") {
        this.catalogo_id = id;
        this.excluir = true;
        this.titulo = "Editar Catálogo";
        this.$http
          .get(this.$urlAPI + "/catalogo/" + id, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            this.catalogo = response.data;
            this.catalogo.ativo = this.catalogo.ativo == "1";
          });
      }
    },
    salvar: function() {
      this.catalogo.ativo = this.catalogo.ativo == true ? "1" : "0";
      if (this.excluir) {
        this.$http
          .post(this.$urlAPI + "/catalogo/" + this.catalogo.id, this.catalogo, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      } else {
        this.$http
          .post(this.$urlAPI + "/catalogo", this.catalogo, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      }
    },
    confirmaExcluir: function() {
      this.exclusao = true;
    },
    deletar: function() {
      this.$http
        .delete(this.$urlAPI + "/catalogo/" + this.catalogo.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.frmcadastro = false;
            this.exclusao = false;
            this.getData();
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    }
  }
};
</script>
